
import { defineComponent, computed } from 'vue';
import HeadingContainer from '@/components/UI/HeadingContainer.vue';
import AlertForm from '@/components/AlertForm.vue';
import { useStore } from '@/store';
import ErrorMessage from '@/components/UI/ErrorMessage.vue';

export default defineComponent({
    name: 'GetUpdates',
    components: { AlertForm, HeadingContainer, ErrorMessage },
    setup () {
        const store = useStore();
        const siteName = computed(() => store.state.siteName);
        const isEmailError = computed(() => store.state.isEmailError);

        return { siteName, isEmailError };
    }
});
